"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var supportive_is_1 = require("@flk/supportive-is");
function isSimple(value) {
    return value === null || ['undefined', 'boolean', 'number', 'string', 'function'].includes((typeof value).trim().toLowerCase());
}
function isReplacer(a, b) {
    return isSimple(b) || supportive_is_1.Is.array(b) || b instanceof Date || b && b.__REPLACE__ || isSimple(a) || supportive_is_1.Is.array(a) || a instanceof Date;
}
function sortObject(object) {
    // simple value type, return as is
    if (isSimple(object))
        return object;
    // array, return map
    if (supportive_is_1.Is.array(object))
        return object.map(sortObject);
    // date, return clone
    if (object instanceof Date)
        return new Date(object.valueOf()); // clone dates
    // return sorted object
    return Object.keys(object)
        .sort()
        .reduce(function (o, k) {
        var _a;
        if (object[k] === undefined || k === '__REPLACE__')
            return o;
        return Object.assign(o, (_a = {}, _a[k] = sortObject(object[k]), _a));
    }, {});
}
function deepMerge(objectA, objectB) {
    // undefined override, return original
    if (objectB === undefined)
        return sortObject(objectA);
    // null override, use undefined
    if (objectB === null)
        return undefined;
    if (isReplacer(objectA, objectB))
        return sortObject(objectB);
    // return sorted object
    return Object.keys(objectA)
        .concat(Object.keys(objectB))
        .concat()
        .sort()
        .filter(function (value, index, array) { return array.indexOf(value) === index; })
        .reduce(function (o, k) {
        var _a;
        var v = deepMerge(objectA[k], objectB[k]);
        return v === undefined ? o : Object.assign(o, (_a = {}, _a[k] = v, _a));
    }, {});
}
function merge() {
    var e_1, _a;
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var masterObject = {};
    try {
        for (var objects_1 = __values(objects), objects_1_1 = objects_1.next(); !objects_1_1.done; objects_1_1 = objects_1.next()) {
            var object = objects_1_1.value;
            masterObject = deepMerge(masterObject, object);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (objects_1_1 && !objects_1_1.done && (_a = objects_1.return)) _a.call(objects_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return masterObject;
}
exports.default = merge;
//# sourceMappingURL=merge.js.map